export function findMostDistinctKeyByHeuristic(inputs?: Record<string, any>[]) {
  if (!inputs?.length) return undefined;

  // Get keys present in all examples
  const commonKeys = Object.keys(inputs[0] ?? {}).filter((key) =>
    inputs.every((input) => key in input)
  );

  if (commonKeys.length === 1) {
    return commonKeys[0];
  } else if (commonKeys.length === 0) {
    return undefined;
  }

  // Score keys based on their usefulness for display
  const keyScores = commonKeys.map((key) => {
    // Get all values for this key
    const values = inputs.map((input) => {
      const value = input[key];
      return typeof value === 'object'
        ? JSON.stringify(value)
        : value.toString();
    });

    // Calculate median length
    const lengths = values.map((v) => v.length).sort((a, b) => a - b);
    const medianLength = lengths[Math.floor(lengths.length / 2)];

    // Length scoring with multiple penalty tiers
    const lengthScore =
      medianLength > 5000
        ? 0.01 // Severe penalty for very long content
        : medianLength > 500
        ? 0.3 // Moderate penalty for long content
        : medianLength < 20
        ? 0.4 // Slight penalty for very short content
        : Math.min(1 - medianLength / 500, 0.9); // Gradually reduce score between 20-500 chars

    const uniqueCount = new Set(values).size;

    const uniquenessScore = uniqueCount / inputs.length;
    const looksLikeUserContent =
      /prompt|query|question|input|message|name/i.test(key);
    const looksLikeMetadata =
      /id$|timestamp|created_at|updated_at|metadata|^_/i.test(key);
    const contentTypeScore = looksLikeMetadata
      ? 0.1
      : looksLikeUserContent
      ? 0.9
      : 0.5;

    return {
      key,
      score: lengthScore * 0.4 + uniquenessScore * 0.3 + contentTypeScore * 0.3,
      medianLength,
      uniqueCount,
      lengthScore,
      looksLikeUserContent,
      contentTypeScore,
    };
  });

  return keyScores.sort((a, b) => b.score - a.score).map((item) => item.key)[0];
}
